import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import blueprints from './Blueprints';

var BlueprintsManager = /*#__PURE__*/function () {
  function BlueprintsManager(_ref) {
    var id = _ref.id;
    // this.eventsCB = config && config.eventsCB;
    this.id = id + "'s blueprintsManager";
    this.currentState = {};
    this.existingBlueprint = {};
    this.cache = {};
    this.api = {};
    this.currentState.totalItemsCount = Infinity;

    this.onBlueprintReady = function () {};
  }

  var _proto = BlueprintsManager.prototype;

  _proto.init = function init(config) {
    this.api = config.api;
    this.currentState.totalItemsCount = config && config.totalItemsCount || this.currentState.totalItemsCount;
  };

  _proto.createBlueprint = /*#__PURE__*/function () {
    var _createBlueprint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var _blueprints$createBlu, blueprint, changedParams, blueprintChanged;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.count('>>>>>>>>>>requestingBlueprint from ' + this.id); //TODO - remove when done :D

              this.currentState.totalItemsCount = params.totalItemsCount || this.api.getTotalItemsCount && this.api.getTotalItemsCount() || this.currentState.totalItemsCount;
              this.currentState.isUsingCustomInfoElements = params.isUsingCustomInfoElements || this.api.isUsingCustomInfoElements && this.api.isUsingCustomInfoElements() || this.currentState.isUsingCustomInfoElements;
              _context.t0 = _objectSpread;
              _context.t1 = _objectSpread({}, params);
              _context.next = 7;
              return this.completeParams(params);

            case 7:
              _context.t2 = _context.sent;
              params = (0, _context.t0)(_context.t1, _context.t2);
              _blueprints$createBlu = blueprints.createBlueprint(params, this.currentState, this.existingBlueprint, this.id, this.currentState.isUsingCustomInfoElements), blueprint = _blueprints$createBlu.blueprint, changedParams = _blueprints$createBlu.changedParams;
              blueprintChanged = Object.values(changedParams).some(function (changedParam) {
                return !!changedParam;
              });
              console.log('>>>did blueprint actually change for: ', this.id, '?', blueprintChanged);
              this.updateLastParamsIfNeeded(params, changedParams);
              this.api.onBlueprintReady({
                blueprint: blueprint,
                blueprintChanged: blueprintChanged
              });
              return _context.abrupt("return", this.cache[params] = this.existingBlueprint = blueprint);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function createBlueprint(_x) {
      return _createBlueprint.apply(this, arguments);
    }

    return createBlueprint;
  }();

  _proto.getMoreItems = /*#__PURE__*/function () {
    var _getMoreItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(currentItemLength) {
      var items;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(currentItemLength < this.currentState.totalItemsCount)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 3;
              return this.api.fetchMoreItems(currentItemLength);

            case 3:
              items = _context2.sent;

              if (items) {
                this.createBlueprint({
                  items: items
                }); //work with the new items...
              }

              _context2.next = 8;
              break;

            case 7:
              if (this.existingBlueprint.styles.slideshowLoop) {
                this.duplicateGalleryItems();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getMoreItems(_x2) {
      return _getMoreItems.apply(this, arguments);
    }

    return getMoreItems;
  }();

  _proto.duplicateGalleryItems = function duplicateGalleryItems() {
    var _this$currentState$it;

    var items = (_this$currentState$it = this.currentState.items).concat.apply(_this$currentState$it, this.currentState.items.slice(0, this.currentState.totalItemsCount));

    this.createBlueprint({
      items: items
    });
  } // ------------------ Get all the needed raw data ---------------------------- //
  ;

  _proto.completeParams =
  /*#__PURE__*/
  function () {
    var _completeParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
      var _ref2, dimensions, container, items, styles, styleParams, options, domId;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref2 = params || {}, dimensions = _ref2.dimensions, container = _ref2.container, items = _ref2.items, styles = _ref2.styles, styleParams = _ref2.styleParams, options = _ref2.options, domId = _ref2.domId;
              styles = _objectSpread(_objectSpread(_objectSpread({}, options), styles), styleParams);
              dimensions = _objectSpread(_objectSpread({}, dimensions), container);
              _context3.next = 5;
              return this.fetchDimensionsIfNeeded(dimensions);

            case 5:
              dimensions = _context3.sent;
              _context3.next = 8;
              return this.fetchItemsIfNeeded(items);

            case 8:
              items = _context3.sent;
              _context3.next = 11;
              return this.fetchStylesIfNeeded(styles);

            case 11:
              styles = _context3.sent;
              return _context3.abrupt("return", {
                dimensions: dimensions,
                items: items,
                styles: styles,
                domId: domId
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function completeParams(_x3) {
      return _completeParams.apply(this, arguments);
    }

    return completeParams;
  }();

  _proto.fetchDimensionsIfNeeded = /*#__PURE__*/function () {
    var _fetchDimensionsIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dimensions) {
      var shouldFetchDimensions;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              shouldFetchDimensions = function shouldFetchDimensions(_dimensions) {
                var should = true;

                if (_dimensions && Object.keys(_dimensions).length > 0) {
                  should = false;
                }

                return should;
              };

              if (!shouldFetchDimensions(dimensions)) {
                _context4.next = 11;
                break;
              }

              _context4.t1 = this.api.fetchDimensions;

              if (!_context4.t1) {
                _context4.next = 7;
                break;
              }

              _context4.next = 6;
              return this.api.fetchDimensions();

            case 6:
              _context4.t1 = _context4.sent;

            case 7:
              _context4.t0 = _context4.t1;

              if (_context4.t0) {
                _context4.next = 10;
                break;
              }

              _context4.t0 = this.currentState.dimensions;

            case 10:
              dimensions = _context4.t0;

            case 11:
              return _context4.abrupt("return", dimensions);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function fetchDimensionsIfNeeded(_x4) {
      return _fetchDimensionsIfNeeded.apply(this, arguments);
    }

    return fetchDimensionsIfNeeded;
  }();

  _proto.fetchItemsIfNeeded = /*#__PURE__*/function () {
    var _fetchItemsIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(items) {
      var shouldFetchItems;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              shouldFetchItems = function shouldFetchItems(_items) {
                var should = true;

                if (_items && _items.length > 0) {
                  should = false;
                }

                return should;
              };

              if (!shouldFetchItems(items)) {
                _context5.next = 11;
                break;
              }

              _context5.t1 = this.api.fetchItems;

              if (!_context5.t1) {
                _context5.next = 7;
                break;
              }

              _context5.next = 6;
              return this.api.fetchItems();

            case 6:
              _context5.t1 = _context5.sent;

            case 7:
              _context5.t0 = _context5.t1;

              if (_context5.t0) {
                _context5.next = 10;
                break;
              }

              _context5.t0 = this.currentState.items;

            case 10:
              items = _context5.t0;

            case 11:
              return _context5.abrupt("return", items);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function fetchItemsIfNeeded(_x5) {
      return _fetchItemsIfNeeded.apply(this, arguments);
    }

    return fetchItemsIfNeeded;
  }();

  _proto.fetchStylesIfNeeded = /*#__PURE__*/function () {
    var _fetchStylesIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(styles) {
      var shouldFetchStyles;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              shouldFetchStyles = function shouldFetchStyles(_styles) {
                var should = true;

                if (_styles && Object.keys(_styles).length > 0) {
                  //TODO - should check if they are ready styles and use ClientLib if not?
                  should = false;
                }

                return should;
              };

              if (!shouldFetchStyles(styles)) {
                _context6.next = 11;
                break;
              }

              _context6.t1 = this.api.fetchStyles;

              if (!_context6.t1) {
                _context6.next = 7;
                break;
              }

              _context6.next = 6;
              return this.api.fetchStyles();

            case 6:
              _context6.t1 = _context6.sent;

            case 7:
              _context6.t0 = _context6.t1;

              if (_context6.t0) {
                _context6.next = 10;
                break;
              }

              _context6.t0 = this.currentState.styles;

            case 10:
              styles = _context6.t0;

            case 11:
              return _context6.abrupt("return", styles);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function fetchStylesIfNeeded(_x6) {
      return _fetchStylesIfNeeded.apply(this, arguments);
    }

    return fetchStylesIfNeeded;
  }();

  _proto.updateLastParamsIfNeeded = function updateLastParamsIfNeeded(_ref3, changedParams) {
    var items = _ref3.items,
        dimensions = _ref3.dimensions,
        styles = _ref3.styles;
    this.currentState.items = changedParams.itemsChanged ? items : this.currentState.items;
    this.currentState.dimensions = changedParams.containerChanged ? _objectSpread({}, dimensions) : this.currentState.dimensions;
    this.currentState.styles = changedParams.stylesChanged ? _objectSpread({}, styles) : this.currentState.styles;
  };

  _proto.eventsListenerWrapper = function eventsListenerWrapper(eventsListenerFunc, originalArgs) {
    var eventHandledInternaly = this.internalEventHandler.apply(this, originalArgs);
    !eventHandledInternaly && eventsListenerFunc.apply(void 0, originalArgs);
  };

  _proto.needMoreItems = function needMoreItems(currentItemLength) {
    this.getMoreItems(currentItemLength);
  };

  return BlueprintsManager;
}();

export { BlueprintsManager as default };